/* --------------------
    Event Handler
-------------------- */
$(document).on("load resize", initStageSlick);
$(window).resize(adjustSidebar);
$(window).on("resize", function () {
    $('.slick-slider').slick('refresh')
});

$(document).ready(function () {
    initStageSlick();
});



/* --------------------
    Functions
-------------------- */

function initStageSlick() {
    if ($('.slider-stage')[0]) {
        $('.slider-stage').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            arrows: false,
            dots: false
        });
    }
}

